import {Action, handleActions} from 'redux-actions';
import Event from '../actions/event';
import {DashboardData, EmployeeRate, YearlyRevenueData} from '../types/Dashboard';
import {
    DashboardDataFetchedPayload,
    EmployeeRateListFetchedPayload,
    YearlyRevenueFetchedPayload,
} from '../actions/dashboardEvent';

export interface DashboardState {
    data: DashboardData | null;
    loading: boolean;
    rates: EmployeeRate[];
    yearlyRevenue: YearlyRevenueData | null;
}

export const dashboardInitialState: DashboardState = {
    data: null,
    loading: false,
    rates: [],
    yearlyRevenue: null,
};

export const dashboardReducer = handleActions<DashboardState, any>(
    {
        [Event.Dashboard.dashboardDataFetched.toString()]:
            (state, action: Action<DashboardDataFetchedPayload>): DashboardState => {
                return {
                    ...state,
                    data: action.payload.data,
                    loading: false,
                };
            },
        [Event.Dashboard.employeeRateListFetched.toString()]:
            (state, action: Action<EmployeeRateListFetchedPayload>): DashboardState => {
                return {
                    ...state,
                    rates: action.payload.rates,
                };
            },
        [Event.Dashboard.yearlyRevenueFetched.toString()]:
            (state, action: Action<YearlyRevenueFetchedPayload>): DashboardState => {
                return {
                    ...state,
                    yearlyRevenue: action.payload.data,
                };
            },
    },
    dashboardInitialState,
);
